export default __webpack_public_path__ + "static/media/canada.7a52d60f.svg";